import {
  Component,
  forwardRef,
  Host,
  Input,
  OnInit,
  Optional,
  SkipSelf,
} from '@angular/core';

import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BehaviorSubject } from 'rxjs';

import { Language } from '../../language';
import {CountryAutocompleteControl, Helper} from '../../classes';

import { AutocompleteOptionInterface } from '../autocomplete';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';

import { CountryAutocompleteItemInterface } from './interfaces';

@Component({
  selector: 'app-country-autocomplete',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CountryAutocompleteComponent),
    multi: true,
  }],
})
export class CountryAutocompleteComponent extends AutocompleteComponent implements OnInit {
  private items: CountryAutocompleteItemInterface[];

  @Input() public currenLanguage: string;
  @Input() public visibleFlagOnSelect: boolean;

  constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer,
  ) {
    super(controlContainer);

    this.items = [];
    this.visibleFlagOnSelect = true;
  }

  private createAutocompleteOptions(): AutocompleteOptionInterface[] {
    return this.items
      .sort((current: CountryAutocompleteItemInterface, next: CountryAutocompleteItemInterface) => {
        const currentName = current.name;
        const nextName = next.name;

        if (currentName < nextName) {
          return -1;
        }

        if (currentName > nextName) {
          return 1;
        }

        return 0;
      })
      .filter((country: CountryAutocompleteItemInterface) => country.id && country.name)
      .map((country: CountryAutocompleteItemInterface) => {
        let label = country.name;

        return {
          label,
          value: country.id,
          classes: this.countryIconClassPrefix + country.id.toLowerCase(),
        };
      });
  }

  ngOnInit(): void {
    this.items = this.asFormsControl().countries;

    this.asFormsControl().options = this.createAutocompleteOptions();

    this.autocompleteOptions = new BehaviorSubject(this.asFormsControl().options);

    this.checkInvalid();
  }

  asFormsControl(): CountryAutocompleteControl {
    if (!this.control || !(this.control instanceof CountryAutocompleteControl)) {
      this.control = new CountryAutocompleteControl({
        name: '',
        value: '',
        placeholder: '',
        validators: [],
        componentType: 0,
        invalid: false,
        errors: [],
        options: [],
        countries: [],
      });
    }

    if ((typeof this.controlPlaceHolder !== 'undefined') && this.control) {
      this.control.placeholder = this.controlPlaceHolder;
    }

    return (this.control as CountryAutocompleteControl);
  }
}
